module.exports = __webpack_public_path__ + "static/img/top.b5fbda50.webp";